/* Kysen Essence — the opening's spec strip.

   Decorative only: everything it says appears elsewhere on the site as
   real content, so it is aria-hidden and built here rather than in
   Liquid. Kept deliberately tiny — this file exists to restore one
   detail of the opening, nothing else.
*/
(function () {
  'use strict';

  function build() {
    if (!document.body.classList.contains('template-index')) return;

    var host = document.querySelector('[id*="__hero_"]');
    if (!host || host.querySelector('.k-hero-spec')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var bits = ['Est. 2026', 'Portland, Oregon', 'Organic huile de parfum', '10 ml'];

    var strip = document.createElement('p');
    strip.className = 'k-hero-spec';
    strip.setAttribute('aria-hidden', 'true');

    bits.forEach(function (b, i) {
      if (i) {
        var dot = document.createElement('span');
        dot.className = 'k-hero-spec__dot';
        strip.appendChild(dot);
      }
      var s = document.createElement('span');
      s.textContent = b;
      if (i === 2) s.className = 'k-hero-spec__hide-sm';   // drops on narrow screens
      strip.appendChild(s);
    });

    host.appendChild(strip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  // The hero re-renders in the theme editor.
  document.addEventListener('shopify:section:load', build);
})();
